<h2 mat-dialog-title>Edit Capa</h2>
<mat-dialog-content>
  <iaud-capa-edit-form [capa]="capa" (isValidChange)="toggleFormValidity($event)"></iaud-capa-edit-form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close>Cancel</button>
  <button mat-raised-button
          [disabled]="!isFormValid"
          [color]="'accent'"
          (click)="update(false)">
          <mat-spinner *ngIf="isSavingLater$ | async" [diameter]="25"></mat-spinner>
          Save And Finish Later
  </button>
  <button mat-raised-button
  class="right-margin"
  (click)="update(true)"
  [disabled]="!isFormValid">
    <mat-spinner *ngIf="isSaving$ | async" [diameter]="25"></mat-spinner>
    Ready To Submit
  </button>
</mat-dialog-actions>
